import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAdConfig, areAdsEnabled } from '../config/ads';

const SCRIPT_ID = 'google-adsense-script';
const SCRIPT_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

function loadAdScript(clientId) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(SCRIPT_ID)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `${SCRIPT_SRC}?client=${clientId}`;
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load ads script'));
    document.head.appendChild(script);
  });
}

export const AdBanner = () => {
  const location = useLocation();
  const adRef = useRef(null);
  const pushedRef = useRef(false);
  const [ready, setReady] = useState(false);

  const config = getAdConfig();
  const publisherId = config?.publisherId ?? null;
  const slotId = config?.slotId ?? null;
  const showAds = areAdsEnabled() && location.pathname !== '/privacy';

  useEffect(() => {
    if (!showAds || !publisherId) return;

    let cancelled = false;

    loadAdScript(publisherId)
      .then(() => {
        if (!cancelled) setReady(true);
      })
      .catch(() => {
        // Ad blockers or network errors — leave container empty
      });

    return () => {
      cancelled = true;
    };
  }, [showAds, publisherId]);

  useEffect(() => {
    if (!ready || !adRef.current || pushedRef.current || !publisherId || !slotId) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch {
      // Silently ignore ad fill errors
    }
  }, [ready, publisherId, slotId]);

  if (!showAds || !publisherId || !slotId) return null;

  return (
    <div
      className="ad-banner-wrap mx-auto mb-1.5 max-w-md pointer-events-auto"
      aria-label="Advertisement"
      data-testid="ad-banner"
    >
      <ins
        ref={adRef}
        className="adsbygoogle ad-banner-slot"
        style={{ display: 'inline-block', width: '100%', maxWidth: '320px', height: '50px' }}
        data-ad-client={publisherId}
        data-ad-slot={slotId}
      />
    </div>
  );
};
